import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { redirecturl } from '../../services/common/redirect';
import {RecordlogEvents} from '../../analytics/RecordEvents'
import { useSelector } from 'react-redux';
const EarnPointsCard = ({ data }) => {
  const { t } = useTranslation();
    const navigate = useNavigate();
    const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
    const userdata = useSelector((state) => state?.userdata?.value?.rnuserdetails);
  const handleRedirect = (e, url,data) => {
    try{PushCT(data?.displaytext)}catch{}
    //e.preventDefault();
    //redirecturl(url, navigate); //due to this redirection back button is not working on first time
    // if(url === 'earnpointspartnerhome') {
    //   navigate('/earn-points');
    //   return false;
    // }
    // if(url === 'nojoombuypoints') {
    //   navigate('/nojoom-buypoints');
    //   return false;
    // }
    e.preventDefault();
    redirecturl(url, navigate);

  };

  const PushCT = (productname)=>{
    RecordlogEvents('Nojoom Product Viewed', {
      'Mobile Number': userdata?.msisdn,
      'Product Viewed': productname,
      Status: "Success",
      'Status Description': "Success",
      'Channel':"WEBPORTAL",
      'Login Type': logintype,
    });
  }


  return (
    <Link
      className="card_style_1 height_100"
      to="#"
      onClick={(e) => handleRedirect(e, data?.redirecturl,data)}
    >
      <div className="card_img">
        <img
          src={
            data?.imageurl ||
            process.env.PUBLIC_URL + '/assets/images/dummy_img.jpg'
          }
          alt=""
          title=""
        />
      </div>
      <div className="card_info text-center">
        <div className="card_info_grp">
          <h4 className="text-ellipsis">{data?.displaytext}</h4>
          <p>{data?.description}</p>
        </div>
        <div className="card_link">
          <Link
            to="#"
            className="hyperlink"
            //onClick={(e) => handleRedirect(e, data?.redirecturl,data)}
          >
            {data?.buttontext}
            <img
              src={
                process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'
              }
              alt=""
              title=""
            />
          </Link>
        </div>
      </div>
    </Link>
  );
};
export default EarnPointsCard;
